"use client";

import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

interface Props {
  items: FaqItem[];
}

/**
 * Accordion-FAQ для info-страниц. Один открытый item, native <details>-like UX
 * с управлением через React state (нужен для одиночного режима).
 *
 * Не требует JS чтобы первый item был «приоткрыт» — все рендерятся в DOM
 * (полезно для SEO: FAQ-текст индексируется без JS).
 */
export function FaqAccordion({ items }: Props) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return (
    <ul className="divide-y divide-border rounded-[12px] border border-border bg-white">
      {items.map((it, idx) => {
        const isOpen = idx === openIdx;
        return (
          <li key={it.q}>
            <button
              type="button"
              onClick={() => setOpenIdx(isOpen ? null : idx)}
              aria-expanded={isOpen}
              className="flex w-full items-center gap-3 px-5 py-4 text-left text-base font-medium text-text transition-colors hover:bg-bg-muted"
            >
              <span className="flex-1">{it.q}</span>
              <svg
                aria-hidden
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                className="h-5 w-5 shrink-0 text-text-subtle transition-transform"
                style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
              >
                <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div hidden={!isOpen} className="px-5 pb-4 text-sm leading-relaxed text-text-muted">
              {it.a}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
